import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)
var urlproxy = 'https://champs-cashier.cc:4000/';
export default new Vuex.Store({
  state: {
    total: 0,
    username: "",
    password: "",
    game: null,
    Bets: [],
    Time: null,
    teams: null,
    user: null,
    jackpot: null,
    lastprint: null,
    usersreport: null,
    gameresults: null,
    GameID: null,
    lastActiveTime: null,
    startdate: new Date().toLocaleDateString('en-CA'),
    enddate: new Date().toLocaleDateString('en-CA'),
    num: 1270,
    interval: null,
  },
  mutations: {
    totalbets(state, total){
      state.total = total;
    },
    offset(state, total){
      state.num = total;
    },
    request(state, request){
      state[request.name] = request.data;
    },
    updateBalance(state, data){
      state.user.Balance = data.Balance;
    },
    addbet(state, bet){
      state.Bets.push(bet.bet);
    },
    logout(state){
      state.username = "";
      state.password = "";
    },
    lastprint(state, props){
      state.lastprint = props;
    }
  },
  actions: {
    logout(context){
      context.commit('logout')
    },
    lastprint(context, props){
      context.commit('lastprint', props)
    },
    settotal(context, total){
      context.commit('totalbets', total)
    },
    setoffset(context, total){
      context.commit('offset', total)
    },
    addbet(context, bet){
      context.commit('addbet', bet)
    },

    apirequest(context, data){
      return axios.get(urlproxy + data.name, {
        headers: {
          'x-access-token': data.token,
          'cashier': data.token
        }                               
      })
      .catch(function (error) {
        console.log(error);
      })
      .then(function (response) {
        if(data.name == "users/balance"){
          context.commit('updateBalance', response.data);
          return response
        }
        if(response.data.GameID == context.state.GameID && response.data.Time > 230 && data.name == "game/kass"){
          return context.dispatch('apirequest', {token: context.state.user.token, name: "game/kass"});
        }
        if(data.name == "game/results" && context.state.gameresults != null){
          if(context.state.gameresults[0].GameID == response.data.GameID){
            return context.dispatch('apirequest', {token: context.state.user.token, name: "game/results"});
          }
        }
        context.commit('request', {name: "GameID", data: response.data.GameID});
        if(data.name.includes('game')){
          response.data.Time = Math.floor(Date.now() + ((response.data.Time) * 1000))
        }
        if(data.name.includes('game') && !data.name.includes('kass')){
          if(context.state.interval) clearInterval(context.state.interval);
          context.state.interval = setInterval(() => {
            if(context.state.Time > 0) {
              context.state.Time = Math.floor((context.state.game.Time - Date.now()) / 1000);
            }else{
              return context.dispatch('apirequest', {token: context.state.user.token, name: "game"});
            }
          }, 1000);
        }
        if(data.name == "game/kass"){
          context.commit('request', {name: 'game', data: response.data});
        }else{
          let name = data.name.replaceAll('/', '');
          name = name.replace(/[0-9]/g, '');
          context.commit('request', {name: name, data: response.data});
        }        
        return response
      });
    },
    
    apirequestPOST(context, data){
      return axios.post(urlproxy + data.name, data.data, {
        headers: {
          'x-access-token': data.token
        }                       
      })
      .catch(function (error) {
        console.log(error);
      })
      .then(function (response) {
          context.commit('request', {name: name.replace('/', ''), data: response.data});
          return response
      });
    },

    report(context, data){
      return axios.get(urlproxy + data.name, {
        headers: {
          'x-access-token': data.token,
          'startdate': data.start,
          'enddate': data.end
        }                       
      })
      .catch(function (error) {
        console.log(error);
      })
      .then(function (response) {
        context.commit('request', {name: data.name.replace('/', ''), data: response.data});
        return response
      });
    },

    login(context, data){
      return axios.post(urlproxy + 'auth/login', {
        login: data.user,
        password: data.pw
      })  
      .catch(function (error) {
        console.log(error);
      })
      .then(function (response) {
          context.commit('request', {name: 'user', data: response.data});
          return response
      });      
    },
  }
});

